<template>
<div class="chapter">
<div class="inner_page">
<div id="lo">
<div class="generated-style">
<p class="gb"> </p>
<p class="gb"> </p>
<p class="gb"> </p>
<p class="gb">Other Books by Jef Mallett</p>
<p class="nor"> </p>
<p class="copy1">Frazz: Live at Bryson Elementary</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// LO-03.vue?0a556300